import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UsuarioServiceProvider } from '../index.providers';
import { AppPlatformService } from '../platform/app-platform.service';
import { ScormPlayerSessionService } from '../scorm-events/scorm-player-session.service';

@Injectable()
export class IdByBrandInterceptor implements HttpInterceptor {
  device_os: string = "web";
  constructor(private up: UsuarioServiceProvider, private appPlatformService:AppPlatformService,
    private scormSession: ScormPlayerSessionService,) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // en el player embebido la sesión vive en memoria; fuera de ahí esto es localStorage
    const token: string = this.scormSession.getItem("token");
    let modifiedReq: HttpRequest<any> = req;

    if (token) {
      let data_usuario = this.scormSession.getUserData();
      this.device_os = this.appPlatformService.isIosHibridApp() ? "ios" : this.appPlatformService.isAndroidHibridApp() ? "android" : "web";


      const workstation = {
        platform: data_usuario?.onboarding ? "onboarding" : "training",
        platform_id: data_usuario?.current_platform?.id,
        workspace: data_usuario?.workspace?.slug,
        workspace_id: data_usuario?.workspace?.id,
        subworkspace: data_usuario?.module?.slug,
        subworkspace_id: data_usuario?.module?.id,
      }

      if (req.method === 'GET') {
        modifiedReq = req.clone({
          params: (req.params || new HttpParams())
          .set('workstation', JSON.stringify(workstation))
          .set('device', this.device_os)
          .set('user_timezone', Intl.DateTimeFormat().resolvedOptions().timeZone)
          // .set('platform_id', workstation.platform_id)
          // .set('workspace', workstation.workspace)
          // .set('workspace_id', workstation.workspace_id)
          // .set('subworkspace', workstation.subworkspace)
          // .set('subworkspace_id', workstation.subworkspace_id)
        });

      } else if (req.body instanceof FormData) {
        // Un `FormData` no se puede desestructurar (`{...formData}` da `{}` y se
        // pierde el archivo): hay que copiarlo campo por campo y añadir los
        // datos de contexto como campos más del multipart. Se copia en vez de
        // mutar el original porque el interceptor puede re-ejecutarse en un
        // reintento y duplicaría las llaves.
        const body = new FormData();
        req.body.forEach((value, key) => body.append(key, value as any));
        body.append('workstation', JSON.stringify(workstation));
        body.append('device', this.device_os);
        body.append('user_timezone', Intl.DateTimeFormat().resolvedOptions().timeZone);

        modifiedReq = req.clone({ body });

      } else {
        let originalBody = req.body;
        // console.log("originalBody",typeof req.body, req.body )

        if(typeof req.body === "string") {
          try {
            const parseBody = JSON.parse(req.body);
            originalBody = parseBody;
          } catch (error) {
            console.log(error)
          }
        };

        const body = { ...originalBody,
          workstation : {
            platform: workstation.platform,
            platform_id: workstation.platform_id,
            workspace: workstation.workspace,
            workspace_id: workstation.workspace_id,
            subworkspace: workstation.subworkspace,
            subworkspace_id: workstation.subworkspace_id,
          },
          device: this.device_os,
          user_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };
        modifiedReq = req.clone({ body });
      };
    };

    return next.handle(modifiedReq);
  }
}
